import { type UseQueryResult, useQuery } from 'react-query';
import { TradeOrderSharedService } from '../../services/wealthlane-award-settlement-services';

const useGetOrderCancelStatus = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const orderCancelStatus = useQuery(
    ['getOrderCancelStatus'],
    async () => {
      return await handleRequest(
        TradeOrderSharedService.getApiAwardSettlementApiAppTradeOrderTradeOrderCancelStatus()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.displayName ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return orderCancelStatus;
};

export default useGetOrderCancelStatus;
